import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-switch-cell-renderer',
  standalone: false,
  templateUrl: './switch-cell-renderer.component.html',
  styleUrl: './switch-cell-renderer.component.scss',
})
export class SwitchCellRendererComponent implements ICellRendererAngularComp {
  value = false;
  params!: ICellRendererParams<any, boolean> & {
    onToggle?: (row: any) => void;
  };

  agInit(params: typeof this.params): void {
    this.params = params;
    this.value = !!params.value;
  }

  refresh(params: typeof this.params): boolean {
    this.value = !!params.value;
    return true;
  }

  onToggle() {
    this.params.onToggle?.(this.params.data);
  }
}
